import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.scss'],
})
export class ServiceCardComponent implements OnInit {
  @Input() serviceCardData: any;

  constructor() { }

  ngOnInit() {}

}
